import {
    BANKLISTFORPARTNER_SUCCESS,
    BANKLISTFORPARTNER_FAILED,
    RESET_BANKLISTFORPARTNER,
    LOADING_BANKLISTFORPARTNER,
    NETWORK_ERROR_BANKLISTFORPARTNER,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_BANKLISTFORPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case BANKLISTFORPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case BANKLISTFORPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_BANKLISTFORPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_BANKLISTFORPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};
